import { pathOr } from 'ramda';
import * as React from 'react';

import { EHouseMaterial } from '../../../types/jsonQuery';
import { NonEmptyArray } from '../../../../../JsonQuery';
import { useContext } from '../../../utils/useContext';
import { useOfferType } from '../../../utils/useOfferType';
import { ConstructionType } from '../../../components/advancedFilters/ConstructionType';

export const ConstructionTypeContainer: React.FC = () => {
  const { jsonQuery, onChange } = useContext();
  const offerType = useOfferType();
  let constructionType = pathOr<EHouseMaterial[] | null>(null, ['house_material', 'value'], jsonQuery);
  if (constructionType && constructionType.length === 0) {
    constructionType = null;
  }

  const handleChange = React.useCallback(
    (constructionType: NonEmptyArray<EHouseMaterial> | null) => {
      onChange({ action: 'setConstructionTypes', arguments: [constructionType] });
    },
    [onChange],
  );

  return (
    <ConstructionType
      offerType={offerType}
      value={constructionType as NonEmptyArray<EHouseMaterial> | null}
      onChange={handleChange}
    />
  );
};
